require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-bezoekers-informatie-centrum.json") })
        }
      }, "path---projecten-bezoekers-informatie-centrum");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-bezoekers-informatie-centrum!./.cache/json/projecten-bezoekers-informatie-centrum.json
// module id = 399
// module chunks = 231608221292675